export enum NotificationPriority {
    Normal,
    High
}
